<template>
  <div class="estimate-comparison-analysis">
    <!-- <el-button type="primary" size="mini" @click="handleSelect"
      >选择估算方案</el-button
    > -->
    <SimpleTable
      height="300px"
      :rowHeight="36"
      ref="topTable"
      table-code="estimateComparisonAnalysisTop"
      :showIndex="false"
      :columns="columns.top"
      :data="tableData.top"
      :loading="loading.top"
      @modify-data-change="onModifyDataChange"
    />
    <el-button type="primary" size="mini" @click="handleReport"
      >生成报表</el-button
    >
    <SimpleTable
      ref="centerTable"
      table-code="estimateComparisonAnalysisCenter"
      :showIndex="false"
      :columns="columns.center"
      :data="tableData.center"
      :loading="loading.center"
    />

    <!-- <SimpleTable
      height="400px"
      ref="bottomTable"
      table-code="estimateComparisonAnalysisBottom"
      :columns="columns.bottom"
      :data="tableData.bottom"
      :loading="loading.bottom"
    /> -->
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import {
  sortRecords,
  dfsFn,
  listToTree,
  addCbFn,
  imgColumn
} from '@/utils/index'

export default {
  name: 'EstimateComparisonAnalysis',
  components: {
    SimpleTable
  },
  data() {
    return {
      // 页面数据
      columns: {
        top: [
          {
            field: '_checkbox',
            title: '',
            width: 30,
            cellType: 'checkbox',
            headerType: 'checkbox',
            multiple: true,
            style: {
              textAlign: 'center',
              fontSize: 14
            },
            canEdit: true,
            headerStyle: {
              bgColor: '#f2f2f2',
              fontSize: 14,
              color: '#333333',
              fontWeight: 'bold',
              textAlign: 'center'
            }
          },
          { field: 'name', title: '方案名称' },
          {
            field: 'picturePath',
            title: '效果图',
            width: 50,
            ...imgColumn('picturePath')
          },
          { field: 'projectName', title: '项目名称' },
          { field: 'regionName', title: '所在区域' },
          { field: 'address', title: '详细地址' },
          { field: 'measurementUnit', title: '计量单位' },
          { field: 'constructionScale', title: '建筑规模' },
          { field: 'estimateAmount', title: '估算金额' },
          { field: 'costIndicator', title: '造价指标' },
          { field: 'breakEvenPoint', title: '盈亏平衡点' },
          { field: 'profitCycle', title: '盈利周期' },
          {
            field: 'order',
            title: '顺序',
            fieldType: 'number',
            scale: 0,
            canModify: true
          }
        ],
        center: [{ field: 'name', title: '估算项目' }],
        bottom: [
          { field: 'name', title: '年月' },
          { field: 'name', title: '月度估算成本' },
          { field: 'name', title: '月度估算收入' },
          { field: 'name', title: '月度净流入' },
          { field: 'name', title: '累计净流入' },
          { field: 'name', title: '月度估算成本' }
        ]
      },
      tableData: {
        top: [],
        center: [],
        bottom: []
      },
      loading: {
        top: false,
        center: false,
        bottom: false
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      this.getSchemeInvestmentEstimateData()
    },

    // 获取方案估算数据
    async getSchemeInvestmentEstimateData() {
      const res = await this.$service.get(
        '/plan-investment-estimate/list',
        {}
      )

      this.tableData.top = sortRecords(res.data || [])
    },

    onModifyDataChange(getModifyData, cleanModifyData) {
      addCbFn(
        this.$service,
        '/plan-investment-estimate/batch',
        getModifyData,
        cleanModifyData
      )
    },

    handleSelect() {
      this.$selectModal({
        title: '选择估算方案',
        columns: [
          { field: 'name', title: '方案名称' },
          { field: 'projectName', title: '项目名称' },
          { field: 'regionName', title: '所在区域' },
          { field: 'address', title: '详细地址' },
          { field: 'measurementUnit', title: '计量单位' },
          { field: 'constructionScale', title: '建筑规模' },
          { field: 'estimateAmount', title: '估算金额' },
          { field: 'costIndicator', title: '造价指标' },
          { field: 'breakEvenPoint', title: '盈亏平衡点' },
          { field: 'profitCycle', title: '盈利周期' }
        ],
        width: '1200px',
        options: this.schemeInvestmentEstimate,
        allowMultiSelect: true,
        confirm: (res, tableData) => {
          // selectedCellInfos.forEach(e =>
          //   this.modifyData.set(e[0].originData, e[0].originData)
          // )
        }
      })
    },

    async handleReport() {
      const arr = this.$refs.topTable.vtable
        .getAllBodyCells()
        .map(e => e[0])
        .filter(e => e.value)
        .map(e => e.originData.id)

      this.loading.center = true
      const res = await this.$service.post('/report/investment', {
        ids: arr,
        type:1
      })
      this.loading.center = false
      if (res.code === 200) {
        dfsFn(
          res?.data?.columnList.filter((e, i) => i !== 0),
          e => (e.style = { textAlign: 'right' })
        )
        this.columns.center = res?.data?.columnList || []
        dfsFn(this.columns.center, e => (e.columns = e.children))
        if (this.columns.center[0]) this.columns.center[0].tree = true

        this.tableData.center = listToTree(res?.data?.dataList || [], -1)
      }
    }
  }
}
</script>

<style scoped>
.estimate-comparison-analysis {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
</style>
